import { useState } from "react";
import { faqs } from "@/mocks/homeContent";
import { useReveal } from "@/hooks/useReveal";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>("q1");
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? "" : id));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div
        ref={ref}
        className={`mx-auto grid w-full grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-12 ${
          visible ? "reveal is-visible" : "reveal"
        }`}
      >
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2">
            <span className="h-4 w-1 rounded-full bg-primary-500" />
            <span className="text-xs font-medium tracking-[0.18em] text-secondary-600">FAQ</span>
          </div>
          <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于会员解锁范围、提前看料与完整版的差别，以及话题墙的使用方式，这里都有说明。
          </p>
          <a
            href="#plans"
            className="mt-6 flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开通会员
            <i className="ri-vip-crown-2-line text-lg" />
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-300 overflow-hidden rounded-lg border border-background-300 bg-background-50">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div key={faq.id}>
                  <button
                    type="button"
                    onClick={() => toggle(faq.id)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {faq.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}